"use strict";

var _type = require("../_utils/type");
var SizeTypes = (0, _type.tuple)('l', 'default', 's');
var MobileSizeTypes = (0, _type.tuple)('xxl', 'default');
var WidthTypes = (0, _type.tuple)('default', 'full');

/**
 * 下拉类组件通用 Props
 */